<div class="settings-shell">
  <aside *ngIf="!isMobile()" aria-label="Settings navigation">
    <h3>Settings</h3>
    <mat-nav-list>
      <a mat-list-item *ngFor="let option of sectionOptions" (click)="switchSection(option.value)"
        [class.active]="section() === option.value">
        <mat-icon matListItemIcon>{{ option.icon }}</mat-icon>
        {{ option.label }}
      </a>
    </mat-nav-list>
  </aside>

  <div class="mobile-section-picker" *ngIf="isMobile()">
    <mat-form-field appearance="outline">
      <mat-label>Section</mat-label>
      <mat-select [value]="section()" (selectionChange)="switchSection($event.value)">
        <mat-option *ngFor="let option of sectionOptions" [value]="option.value">
          <mat-icon aria-hidden="true">{{ option.icon }}</mat-icon>
          <span>{{ option.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button (click)="close()" aria-label="Close settings">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <section class="content" *ngIf="section() === 'account'">
    <header>
      <div>
        <h2>Account</h2>
        <p>Profile info pulled from your Google account.</p>
      </div>
      <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </header>
    <mat-divider></mat-divider>
    <div class="body">
      <p>Your name and avatar mirror your Google profile. Updates there will sync the next time you sign in.</p>
    </div>
  </section>

  <section class="content" *ngIf="section() === 'families'">
    <header>
      <div>
        <h2>Families</h2>
        <p>Choose a home base, share invite codes, and review pending requests.</p>
      </div>
      <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </header>
    <mat-divider></mat-divider>
    <div class="body families">
      <div class="family-card" *ngFor="let family of families">
        <div class="family-details">
          <h3>{{ family.name || 'Untitled family' }}</h3>
          <p>Role: <strong>{{ roleLabel(family.role) }}</strong></p>
          <p>Members: {{ family.memberCount ?? 0 }}</p>
          <p *ngIf="family.joinCode">Invite code: <strong>{{ family.joinCode }}</strong></p>
          <p *ngIf="(family.pendingRequestCount ?? 0) > 0">
            Pending requests: {{ family.pendingRequestCount ?? 0 }}
          </p>
          <mat-chip color="primary" *ngIf="selectedFamilyId === family.id">Current workspace</mat-chip>
          <div class="avac-toggle" *ngIf="family.role === 'parent'">
            <mat-slide-toggle [checked]="family.avacSubmissionEnabled ?? false"
              (change)="toggleAvacSubmission(family, $event.checked)" [disabled]="isAvacToggleLoading(family.id)">
              AVAC submissions
            </mat-slide-toggle>
            <small>Track signed, submitted, and paid checkpoints every Thursday.</small>
            <mat-progress-bar mode="indeterminate" *ngIf="isAvacToggleLoading(family.id)"></mat-progress-bar>
          </div>
          <div class="budget-toggle" *ngIf="family.role === 'parent'">
            <mat-slide-toggle [checked]="family.budgetingEnabled ?? false"
              (change)="toggleBudgeting(family, $event.checked)" [disabled]="isBudgetToggleLoading(family.id)">
              Budgeting component
            </mat-slide-toggle>
            <small>Plan bills, income, and wish lists with AUD conversions.</small>
            <mat-progress-bar mode="indeterminate" *ngIf="isBudgetToggleLoading(family.id)"></mat-progress-bar>
          </div>
          <div class="recipes-toggle" *ngIf="family.role === 'parent'">
            <mat-slide-toggle [checked]="family.recipesEnabled ?? false"
              (change)="toggleRecipes(family, $event.checked)" [disabled]="isRecipeToggleLoading(family.id)">
              Recipes & planner
            </mat-slide-toggle>
            <small>Share ingredients, steps, and plan weekly meals together.</small>
            <mat-progress-bar mode="indeterminate" *ngIf="isRecipeToggleLoading(family.id)"></mat-progress-bar>
          </div>
          <div class="sleep-toggle" *ngIf="family.role === 'parent'">
            <mat-slide-toggle [checked]="family.sleepTrackingEnabled ?? false"
              (change)="toggleSleepTracking(family, $event.checked)"
              [disabled]="isSleepTrackingToggleLoading(family.id)">
              Toddler Sleep Tracker
            </mat-slide-toggle>
            <small>Track sleep sessions, night wakings, and get recommendations.</small>
            <mat-progress-bar mode="indeterminate" *ngIf="isSleepTrackingToggleLoading(family.id)"></mat-progress-bar>
          </div>
        </div>
        <div class="actions">
          <button mat-stroked-button color="primary" (click)="selectFamily(family.id)">Switch</button>
          <button mat-stroked-button color="accent" *ngIf="family.role === 'parent'"
            (click)="toggleJoinRequests(family)">
            {{ expandedFamilyId() === family.id ? 'Hide requests' : 'Review requests' }}
          </button>
        </div>

        <div class="join-requests" *ngIf="expandedFamilyId() === family.id">
          <div class="join-requests-header">
            <h4>Join requests</h4>
            <span *ngIf="joinRequests().length > 0">{{ joinRequests().length }} waiting</span>
          </div>
          <mat-progress-bar mode="indeterminate" *ngIf="joinRequestsLoading()"></mat-progress-bar>
          <p *ngIf="!joinRequestsLoading() && joinRequests().length === 0" class="empty-state">
            No pending requests for this family.
          </p>
          <div class="join-request" *ngFor="let request of joinRequests()">
            <div class="details">
              <strong>{{ request.requesterName }}</strong>
              <p>{{ request.requesterEmail || 'No email provided' }}</p>
              <small>Requested {{ request.requestedAt | date: 'medium' }}</small>
            </div>
            <div class="request-actions">
              <mat-form-field appearance="outline">
                <mat-label>Role</mat-label>
                <mat-select [value]="getRoleSelection(request.id)"
                  (selectionChange)="setRoleSelection(request.id, $event.value)">
                  <mat-option *ngFor="let role of familyRoleOptions" [value]="role.value">
                    {{ role.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="request-buttons">
                <button mat-stroked-button color="primary" (click)="approveRequest(family.id, request.id)"
                  [disabled]="joinRequestsLoading()">
                  Approve
                </button>
                <button mat-button color="warn" (click)="denyRequest(family.id, request.id)"
                  [disabled]="joinRequestsLoading()">
                  Decline
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button mat-flat-button color="accent" (click)="openInviteDialog()">Create or join another family</button>
    </div>
  </section>

  <section class="content" *ngIf="section() === 'preferences'">
    <header>
      <div>
        <h2>Preferences</h2>
        <p>Keep Fruitage consistent across devices.</p>
      </div>
      <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </header>
    <mat-divider></mat-divider>
    <div class="body preferences">
      <div class="preference-card">
        <div>
          <h3>Appearance</h3>
          <p>Switch between the Material 3 light and dark palettes.</p>
        </div>
        <mat-slide-toggle [checked]="usingDarkMode()" (change)="toggleDarkMode($event.checked)">
          Dark mode
        </mat-slide-toggle>
      </div>
      <p class="coming-soon">Notification toggles and routine reminders will land here next.</p>
    </div>
  </section>
</div>